import { useEffect, useRef, useState } from "react";

const STATUS_OPTIONS = [
  {
    value: "aktif",
    label: "Aktif",
    color: "text-emerald-400",
    bgActive: "bg-emerald-600",
    dotColor: "bg-emerald-400",
  },
  {
    value: "nonaktif",
    label: "Nonaktif",
    color: "text-red-400",
    bgActive: "bg-red-600",
    dotColor: "bg-red-400",
  },
  {
    value: "suspend",
    label: "Suspend",
    color: "text-amber-400",
    bgActive: "bg-amber-600",
    dotColor: "bg-amber-400",
  },
];

export const SelectPppoeStatus = ({
  label,
  value, // string: "aktif" | "nonaktif" | "suspend"
  setValue,
  onChange, // akan menerima string value
  placeholder = "Pilih Status",
}) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  // Cari opsi yang sedang terpilih
  const selected = STATUS_OPTIONS.find((opt) => opt.value === value);

  // Menutup dropdown jika klik di luar komponen
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Handler untuk seleksi item
  const handleSelect = (selectedValue) => {
    setOpen(false);

    // Jika memilih placeholder (reset)
    const payload = selectedValue === "" ? null : selectedValue;

    if (onChange) {
      onChange(payload);
    } else if (setValue) {
      setValue(payload);
    }
  };

  return (
    <div className="w-full relative text-xs" ref={wrapperRef}>
      {label && (
        <label className="font-medium text-white uppercase mb-1 block">
          {label}
        </label>
      )}

      {/* Select Box */}
      <div
        onClick={() => setOpen(!open)}
        className={`w-full flex items-center justify-between px-3 py-2 mt-2 border rounded-md focus:outline-none focus:ring-1 transition-all cursor-pointer
          ${open ? "ring-1 ring-indigo-500 border-indigo-500" : "border-white/20"}
        `}
      >
        <span
          className={`text-ellipsis line-clamp-1 flex items-center gap-2 ${
            !selected ? "text-white/70" : "text-white"
          }`}
        >
          {selected ? (
            <>
              <span
                className={`w-2 h-2 rounded-full ${selected.dotColor} inline-block`}
              />
              <span className={selected.color}>{selected.label}</span>
            </>
          ) : (
            placeholder
          )}
        </span>
        <span className="text-white text-xs ml-2">{open ? "▲" : "▼"}</span>
      </div>

      {/* Dropdown Menu */}
      {open && (
        <div className="absolute z-50 mt-1 w-full bg-slate-800 border border-white/20 rounded-lg shadow-lg overflow-hidden">
          <div className="max-h-60 overflow-y-auto">
            {/* Opsi Reset */}
            <div
              onClick={() => handleSelect("")}
              className={`px-3 py-2 cursor-pointer transition-colors uppercase border-b border-white/5
                ${
                  !selected
                    ? "bg-indigo-600 text-white font-semibold"
                    : "text-white/70 hover:bg-white/10"
                }
              `}
            >
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-white/30 inline-block" />
                <span>Pilih Status</span>
              </div>
            </div>

            {/* List Options */}
            {STATUS_OPTIONS.map((opt) => {
              const isSelected = selected?.value === opt.value;
              return (
                <div
                  key={opt.value}
                  onClick={() => handleSelect(opt.value)}
                  className={`px-3 py-2 cursor-pointer transition-colors uppercase border-b border-white/5 last:border-0
                    ${
                      isSelected
                        ? `${opt.bgActive} text-white font-semibold`
                        : "text-white/80 hover:bg-white/10"
                    }
                  `}
                >
                  <div className="flex items-center gap-2">
                    <span
                      className={`w-2 h-2 rounded-full ${
                        isSelected ? "bg-white" : opt.dotColor
                      } inline-block`}
                    />
                    <span className={isSelected ? "text-white" : opt.color}>
                      {opt.label}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};